/**
 * Sync KM header cart badge with AJAX cart updates (Horizon dispatches cart:update on add/remove).
 * km_header_main uses Liquid for initial count only; core cart-icon is not used there.
 */
(function () {
  'use strict';

  var CART_UPDATE = 'cart:update';

  function renderAll(safe) {
    document.querySelectorAll('[data-km-cart-count]').forEach(function (node) {
      node.textContent = safe < 100 ? String(safe) : '';
      node.hidden = safe === 0;
    });

    try {
      sessionStorage.setItem(
        'cart-count',
        JSON.stringify({
          value: String(safe),
          timestamp: Date.now(),
        })
      );
    } catch (_) {
      /* no-op */
    }
  }

  /**
   * @param {Event & { detail?: { resource?: { item_count?: number }; data?: Record<string, unknown> } }} event
   */
  function onCartUpdate(event) {
    var detail = event.detail;
    if (!detail) return;

    var data = detail.data || {};
    var resource = detail.resource;
    var fromProductForm = data.source === 'product-form-component';
    var delta = typeof data.itemCount === 'number' ? data.itemCount : 0;

    var totalCount;
    if (resource != null && typeof resource.item_count === 'number') {
      totalCount = resource.item_count;
    } else if (fromProductForm) {
      var el = document.querySelector('[data-km-cart-count]');
      var raw = el && el.textContent != null ? el.textContent.trim() : '0';
      var cur = parseInt(raw, 10);
      if (!Number.isFinite(cur)) cur = 0;
      totalCount = cur + delta;
    } else {
      totalCount = delta;
    }

    if (!Number.isFinite(totalCount)) return;
    renderAll(Math.max(0, totalCount));
  }

  function hydrateFromSession() {
    var el = document.querySelector('[data-km-cart-count]');
    if (!el) return;

    try {
      var stored = sessionStorage.getItem('cart-count');
      if (stored === null) return;

      var parsed = JSON.parse(stored);
      var visible = el.textContent.trim();

      if (String(parsed.value) === visible) return;

      if (Date.now() - parsed.timestamp < 10000) {
        var count = parseInt(parsed.value, 10);
        if (Number.isFinite(count) && count >= 0) {
          renderAll(count);
        }
      }
    } catch (_) {
      /* no-op */
    }
  }

  document.addEventListener(CART_UPDATE, onCartUpdate);

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      hydrateFromSession();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateFromSession);
  } else {
    hydrateFromSession();
  }
})();
